import { ITEM_LIST_SUCCESS, ITEM_VARIANT_SUCCESS } from "../constants";

const initialState = {
  list: [],
  listItemVariants: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
  case ITEM_LIST_SUCCESS:
    return {
      ...state,
      list: action.payload
    };
  case ITEM_VARIANT_SUCCESS:
    return {
      ...state,
      listItemVariants: action.payload.itemVariants
    };
  default:
    return state;
  }
}